class Fetcher {
  public static get = async <T>(uri: string): Promise<T | null> => {
    try {
      const res = await fetch(uri)

      if (res.ok) return await res.json()

      return null
    } catch (error: any) {
      console.error('Fetcher', error.message)
      return null
    }
  }
}

export default Fetcher
